import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetQuoteById as GetQuoteByIdQuery,
    GetQuoteByIdVariables as GetQuoteByIdVariables,
    GetQuoteById_quote as Quote,
} from 'nutshell-graphql-types';

import GET_QUOTE_BY_ID from '../queries/get-quote-by-id.graphql';

export const useGetQuoteById = (
    id: string
): {
    quote: Quote | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetQuoteByIdQuery, GetQuoteByIdVariables>(
        GET_QUOTE_BY_ID,
        {
            variables: {
                id,
            },
        }
    );

    const quote = data ? data.quote : null;

    return {
        quote,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
